<template>
    <div class="atelier-card-pic-container" :class="`card-pic-${data.colorIndex - 3}`">
        <div class="atelier-top">
            <div class="atelier-title">
                <CommonComponentsProductsTitleFunctionTitle
                    :function-title="functionTitle"
                    :color-index="data.colorIndex"
                />
            </div>
            <div class="atelier-card">
                <div v-for="(textItem, textIndex) in textList" :key="textIndex" class="atelier-card-text">
                    <div class="atelier-card-text-yes">
                        <CommonComponentsSVGCommonCheckIcon />
                    </div>
                    <div class="atelier-card-text-info">
                        <div
                            ref="title"
                            class="atelier-card-text-title"
                            :class="`atelier-card-title-${textIndex}`"
                            v-html="$t(textItem.title)"
                        />
                        <div
                            ref="subtitle"
                            class="atelier-card-text-subtitle"
                            :class="`atelier-card-subtitle-${textIndex}`"
                            v-html="$t(textItem.subtitle)"
                        />
                    </div>
                </div>
                <div class="atelier-card-button" :class="`card-button-${data.colorIndex - 3}`">
                    <button class="button-download">{{ $t(button.button1) }}</button>
                    <button class="button-require">{{ $t(button.button2) }}</button>
                </div>
            </div>
        </div>
        <div class="atelier-bottom" :style="`background-image: url(${data.bgImage});`">
            <div ref="covertext" class="atelier-bottom-covertext" :class="`bottom-covertext-${data.colorIndex - 3}`">
                {{ $t(data.picCoverText) }}
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    // import { gsap } from 'gsap';
    // import { ScrollTrigger, TimelineMax, Back } from 'gsap/all';
    // import 'https://cdn.skypack.dev/@miii/vue-lettering';
    // import 'https://unpkg.com/@miii/vue-lettering/dist/vue-lettering';
    // gsap.registerPlugin(ScrollTrigger);

    defineProps<{
        data: {
            bgImage: string;
            colorIndex: number;
            picCoverText: string;
        };
        textList: Array<FunctionTitle>;
        functionTitle: FunctionTitle;
    }>();
    const button = reactive({
        button1: 'global_atelier_card_button1',
        button2: 'global_atelier_card_button2',
    });
    const subtitle = ref(null);
    const title = ref(null);
    onMounted(() => {
        // console.log(title.value[0]);

        addSlideInUp('.atelier-title');
        addTextScrollLine(title.value);
        addTextScrollLine(
            '.card-pic-2 .atelier-card-title-0 .colorText',
            {
                backgroundImage:
                    'linear-gradient(75deg,rgba(1,255,0,1) 0%, rgba(1,255,0,1) 33.3%,rgba(255,255,255,0) 66.7%,rgba(255,255,255,0) 100%)',
            },
            {
                color: '#0F0',
            },
        );
        addTextScrollLine(
            subtitle.value,
            {
                backgroundImage:
                    'linear-gradient(75deg,rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.8) 33.3%,rgba(255,255,255,0) 66.7%,rgba(255,255,255,0) 100%)',
            },
            { color: 'rgba(255,255,255,0.8)' },
        );
        addTextBounce('.atelier-bottom-covertext'); // 跳动文字
        // addTextScrollLine('.card-pic-2 .atelier-card-title-0 .colorText' ,{ backgroundImage: 'linear-gradient(75deg,#0F0; 0%, #0F0; 33.3%,rgba(255,255,255,0) 66.7%,rgba(255,255,255,0) 100%)' });
        // const hhh =document.querySelector('.card-pic-2 .atelier-card-title-0 .colorText' )
        // console.log(hhh);

        // const element = document.querySelector('.bottom-covertext-1') as HTMLElement;
        // // console.log(element);

        // const str = element.innerText;
        // // console.log(str);
        // let result = '';

        // for (let i = 0; i < str.length; i++) {
        //     result += `<span>${str.charAt(i)}</span>`;
        //     element.innerHTML = result;
        // }

        // const annimation = () => {
        //     // const timeLineMax = new TimelineMax();
        //     ScrollTrigger.create({
        //         markers: { startColor: 'green', endColor: 'red', fontSize: '12px' },

        //         trigger: '.atelier-bottom-covertext',
        //         // scrub: true,
        //         start: 'top-=20% center',
        //         end: '70% 80%',
        //         animation: gsap.fromTo(
        //             '.atelier-bottom-covertext span',
        //             { ease: Back.easeInOut.config(1.7), opacity: 0, y: -100 },
        //             { ease: Back.easeInOut.config(1.7), opacity: 1, y: 0, stagger: 0.04, duration: 0.5 },
        //         ),
        //     });
        //     // timeLineMax.staggerFromTo(
        //     //     // 最后一个参数，每个的间隔
        //     //     '.atelier-bottom-covertext span',
        //     //     0.5,
        //     //     { ease: Back.easeInOut.config(1.7), opacity: 0, y: -100 },
        //     //     { ease: Back.easeInOut.config(1.7), opacity: 1, y: 0 },
        //     //     0.05,
        //     // );
        // };
        // annimation();
    });
</script>

<style lang="less" scoped>
    .atelier-card-pic-container {
        .atelier-top {
            .atelier-title {
                margin: 0 .convert(80px) [ @vw];
            }
            .atelier-card {
                border-radius: 20px;
                background: #161616;
                height: .convert(651px) [ @vw]; //
                width: .convert(1200px) [ @vw];
                display: flex;
                flex-direction: column;
                margin: 0 auto;
                margin-top: .convert(40px) [ @vw];
                margin-bottom: .convert(60px) [ @vw];
                padding: .convert(44px) [ @vw] 0 0 .convert(41px) [ @vw];
                .atelier-card-text {
                    display: flex;
                    font-family: HarmonyOS Sans SC;
                    font-weight: 400;
                    margin-bottom: .convert(64px) [ @vw];
                    .atelier-card-text-yes {
                        margin-right: .convert(16px) [ @vw];
                        width: .convert(27px) [ @vw];
                        height: .convert(56px) [ @vw];
                        @media (max-width: @screen-mobile-width) {
                            // font-size: .convert(@font-size-xm) [ @vw-mobile]; //14px
                            width: .convert(8px) [ @vw-mobile];
                            height: .convert(16px) [ @vw-mobile];
                        }

                        .svg-check-icon {
                            width: 100%;
                            height: auto;
                        }
                    }
                    .atelier-card-text-info {
                        .atelier-card-text-title {
                            // color: #0f0;
                            font-size: .convert(40px) [ @vw];
                            line-height: normal;
                            margin-bottom: .convert(20px) [ @vw];
                        }

                        .atelier-card-text-subtitle {
                            color: #fff;
                            font-size: .convert(@font-size-xl) [ @vw]; //24px
                            line-height: 160%; /* 38.4px */
                            opacity: 0.8;
                        }
                    }
                }
                .atelier-card-button {
                    display: flex;
                    margin: 0 auto;
                    margin-top: .convert(80px-64px) [ @vw];
                    gap: .convert(40px) [ @vw];
                    font-size: .convert(@font-size-md) [ @vw]; //14px
                    color: #000000;
                    button {
                        width: .convert(133px) [ @vw];
                        height: .convert(53px) [ @vw];
                        padding: .convert(16px) [ @vw];
                        border-radius: .convert(83px) [ @vw];
                        border: none;
                        line-height: 100%;
                        &:hover {
                            background: #f0f;
                            transition: background 0.5s;
                        }
                        transition: background 0.7s;
                    }
                }
            }
        }
        .atelier-bottom {
            background-size: cover;
            height: .convert(582px) [ @vw]; //
            position: relative;
            .atelier-bottom-covertext {
                display: flex;
                position: absolute;
                text-align: center;
                font-size: .convert(250px) [ @vw];
                font-family: 'BoutiqueBitmap9x9 1.5';
                line-height: normal;
                font-weight: 700;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -15%);
            }
        }
    }
</style>
